export const isNotEmptyString = (value: unknown): value is string =>
	typeof value === 'string' && value !== '';
